import React__default from 'react';
import getRendererWithHeadingForResultType from './RendererWithLocalizedHeadingFactory.js';
import FlyoutResult from './FlyoutResult.js';
import ResultText from './ResultText.js';
import { SquareImageContainer, tokens, FluidImage, Typography, VisuallyHidden } from '@vp/swan';

var Result = function Result(_ref) {
  var _result$_highlightRes;
  var result = _ref.result;
  var label = result === null || result === void 0 || (_result$_highlightRes = result._highlightResult) === null || _result$_highlightRes === void 0 || (_result$_highlightRes = _result$_highlightRes.title) === null || _result$_highlightRes === void 0 ? void 0 : _result$_highlightRes.value;
  var ariaTitle = "".concat(result === null || result === void 0 ? void 0 : result.title);
  return /*#__PURE__*/React__default.createElement(FlyoutResult, {
    resultId: result.objectID,
    result: result,
    landingUrl: result.landingUrl
  }, /*#__PURE__*/React__default.createElement(SquareImageContainer, {
    bgc: "strong",
    style: {
      width: tokens.SwanSemSpace9,
      flexShrink: 0,
      borderRadius: tokens.SwanSemBorderRadiusStandard
    }
  }, /*#__PURE__*/React__default.createElement(FluidImage, {
    src: result.imageUrl,
    alt: ""
  })), /*#__PURE__*/React__default.createElement(Typography, {
    className: "search-flyout-item-name",
    textAlign: "left",
    pl: 3,
    pr: 2,
    ml: 3
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement(ResultText, {
    resultText: label
  })), /*#__PURE__*/React__default.createElement(VisuallyHidden, null, ariaTitle)));
};
var ImageFlyoutTaxonomyRenderer = getRendererWithHeadingForResultType(Result);

export { ImageFlyoutTaxonomyRenderer as default };
//# sourceMappingURL=FlyoutRendererWithImage.js.map
